import { createApiAction } from '../utils';
import * as types from './types';

function apiCallAction<M extends types.ServiceMethod, A>(method: M, args: A) {
  return createApiAction(types.ACTION_KEY, method, args);
}

export function getEmbedConfiguration(
  wid: string,
): types.GetConfigurationAction {
  return apiCallAction(types.ServiceMethod.GET_CONFIGURATION, [
    wid,
  ] as types.GetConfigurationArgs);
}

export function createEmbedConfiguration(
  args: types.CreateConfigurationArgs,
): types.CreateConfigurationAction {
  return apiCallAction(types.ServiceMethod.CREATE_CONFIGURATION, args);
}

export function getLockSpec(
  args: types.GetLockSpecArgs,
): types.GetLockSpecAction {
  return apiCallAction(types.ServiceMethod.GET_LOCK_SPEC, args);
}
